<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="row">
        <template v-if="cartProducts.length > 0">
          <div class="container">
            <div class="card card-cart-products col-sm-12">
              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="(item, index) in cartProducts" :key="index">
                  <div class="row">
                    <div class="col-6 col-sm-2" @click="navigateProductDetail(item)">
                      <img
                        class="armaq-top mt-2"
                        v-bind:src="imgPreUrl + item.photo_product + '.jpg'"
                        alt="Card image cap"
                        style="width: 100px;"
                      />
                    </div>
                    <div class="col-6 col-sm-7 margen-automatico">
                      <template v-if="item.subproduct.id_lote == 0">
                        <p>
                          <strong>{{ item.name_product_es }}</strong>
                        </p>
                      </template>
                      <template v-else>
                        <p>
                          <strong>{{
                            item.name_product_es + ' Lote: ' + item.subproduct.lote_sku
                          }}</strong>
                        </p>
                      </template>
                      <p>
                        {{ item.price_product | currency }} X
                        <span class="span-cantidad-calculator"
                          ><strong>{{ item.qty }} </strong></span
                        >
                      </p>
                      <p>
                        <strong>{{ (item.price_product * item.qty) | currency }}</strong>
                      </p>
                    </div>
                    <div class="col-12 col-sm-3 margen-automatico">
                      <div class="btn-group btn-ancho-total">
                        <div class="row">
                          <template v-if="item.subproduct.id_lote == 0">
                            <div class="col-12">
                              <number-input
                                v-model="item.qty"
                                :min="1"
                                :max="item.stock_product"
                                center
                                controls
                                @change="modifyPriceinDisplay()"
                              ></number-input>
                            </div>
                            <div class="col-12">
                              <br /><button
                                type="button"
                                class="btn btn-al-celeste-solid btn-sm ancho-total"
                                v-on:click="removeProductCart(item)"
                              >
                                Eliminar <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </template>
                          <template v-else>
                            <div class="col-12">
                              <number-input
                                v-model="item.qty"
                                :min="1"
                                :max="item.subproduct.lote_stock"
                                center
                                controls
                                @change="modifyPriceinDisplay()"
                              ></number-input>
                            </div>
                            <div class="col-12">
                              <br /><button
                                type="button"
                                class="btn btn-al-celeste-solid btn-sm ancho-total"
                                v-on:click="removeProductCart(item)"
                              >
                                Eliminar <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="error-template container">
            <h2>Su carrito está vacío</h2>
            <div class="error-details">Agrega productos ahora >></div>
            <div class="error-actions">
              <router-link to="/productos">Seguir comprando</router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="container">
        <br />
        <p>
          <strong>NOTA:</strong> Este es un producto de alta demanda, por esta razón le sugerimos
          realizar su compra lo antes posible. Recuerde que el añadir el producto al carrito no
          reserva el producto.
        </p>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { config_settings } from '@/config.js';

export default {
  name: 'CartDetails',
  props: ['cartProducts'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  methods: {
    ...mapMutations(['SET_CART_PRODUCTS']),

    removeProductCart(product) {
      var products = JSON.parse(localStorage.getItem('iki-cart'));
      for (let i = 0; i < products.length; i++) {
        if (products[i].code_product === product.code_product) {
          products.splice(i, 1);
        }
      }
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.$parent.analizeCart();
    },

    modifyPriceinDisplay() {
      var products = this.cartProducts;
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.$parent.analizeCart();
    },

    navigateProductDetail(product) {
      this.$router.push({
        name: 'detalle-productos',
        params: { id: product.code_product },
      });
    },
  },
};
</script>
